{
  "checkedAt": "2026-10-15",
  "facilities": [
    {
      "id": "wallops-cdas",
      "name": "Wallops CDAS",
      "operator": "NOAA",
      "location": "Wallops Island, Virginia",
      "sourceTitle": "NOAA facility reference",
      "sourceUrl": "https://www.nesdis.noaa.gov/about/our-offices/office-of-satellite-and-product-operations-ospo/wallops-command-and-data-acquisition-station",
      "role": "Command and data acquisition",
      "members": [
        {
          "network": "noaa",
          "antennaId": "wallops_26m"
        },
        {
          "network": "noaa",
          "antennaId": "wallops_18m_a"
        },
        {
          "network": "noaa",
          "antennaId": "wallops_164m_hr1"
        },
        {
          "network": "noaa",
          "antennaId": "wallops_164m_hr2"
        },
        {
          "network": "noaa",
          "antennaId": "wallops_164m_hr4"
        },
        {
          "network": "noaa",
          "antennaId": "wallops_164m_hr5"
        },
        {
          "network": "noaa",
          "antennaId": "wallops_164m_hr6"
        },
        {
          "network": "noaa",
          "antennaId": "wallops_142m"
        },
        {
          "network": "noaa",
          "antennaId": "wallops_13m_a"
        },
        {
          "network": "noaa",
          "antennaId": "wallops_13m_b"
        },
        {
          "network": "noaa",
          "antennaId": "wallops_8m"
        },
        {
          "network": "noaa",
          "antennaId": "wallops_72m"
        },
        {
          "network": "noaa",
          "antennaId": "wallops_38m_1"
        },
        {
          "network": "noaa",
          "antennaId": "wallops_38m_2"
        },
        {
          "network": "noaa",
          "antennaId": "wallops_38m_3"
        },
        {
          "network": "noaa",
          "antennaId": "wallops_12m"
        }
      ],
      "lat": 37.946042625000004,
      "lon": -75.4611734375,
      "extentM": 354.1015721572512,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/wallops-cdas.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "fairbanks-cdas",
      "name": "Fairbanks CDAS",
      "operator": "NOAA",
      "location": "Fairbanks, Alaska",
      "sourceTitle": "NOAA facility reference",
      "sourceUrl": "https://www.nesdis.noaa.gov/about/our-offices/office-of-satellite-and-product-operations-ospo/fairbanks-command-and-data-acquisition-station-fcdas",
      "role": "Polar satellite command and data acquisition",
      "members": [
        {
          "network": "noaa",
          "antennaId": "fairbanks_26m"
        },
        {
          "network": "noaa",
          "antennaId": "fairbanks_21m"
        },
        {
          "network": "noaa",
          "antennaId": "fairbanks_13m_a"
        },
        {
          "network": "noaa",
          "antennaId": "fairbanks_13m_b"
        },
        {
          "network": "noaa",
          "antennaId": "fairbanks_13m_c"
        },
        {
          "network": "noaa",
          "antennaId": "fairbanks_5m_mal"
        },
        {
          "network": "noaa",
          "antennaId": "fairbanks_5m_dat"
        },
        {
          "network": "noaa",
          "antennaId": "fairbanks_406m"
        },
        {
          "network": "noaa",
          "antennaId": "fairbanks_24m"
        },
        {
          "network": "noaa",
          "antennaId": "fairbanks_24m_b"
        }
      ],
      "lat": 64.97366530000002,
      "lon": -147.5088145,
      "extentM": 613.6228357709388,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/fairbanks-cdas.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "barrow",
      "name": "Utqiagvik / Barrow",
      "operator": "NOAA",
      "location": "Utqiagvik (Barrow), Alaska",
      "sourceTitle": "NOAA facility reference",
      "sourceUrl": "https://www.nesdis.noaa.gov/about/our-offices/office-of-satellite-and-product-operations-ospo/fairbanks-command-and-data-acquisition-station-fcdas",
      "role": "Remote terminals operated from Fairbanks",
      "members": [
        {
          "network": "noaa",
          "antennaId": "barrow_5m"
        },
        {
          "network": "noaa",
          "antennaId": "barrow_24m"
        }
      ],
      "lat": 71.32347200000001,
      "lon": -156.6107155,
      "extentM": 180,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/barrow.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "suitland",
      "name": "Suitland · NSOF",
      "operator": "NOAA",
      "location": "Suitland, Maryland",
      "sourceTitle": "NOAA facility reference",
      "sourceUrl": "https://www.goes-r.gov/ground/facilities-antennas.html",
      "role": "Satellite mission operations",
      "members": [
        {
          "network": "noaa",
          "antennaId": "suitland_91m_1"
        },
        {
          "network": "noaa",
          "antennaId": "suitland_91m_2"
        },
        {
          "network": "noaa",
          "antennaId": "suitland_91m_3"
        },
        {
          "network": "noaa",
          "antennaId": "suitland_91m_4"
        }
      ],
      "lat": 38.85208,
      "lon": -76.93611,
      "extentM": 180,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/suitland.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "fairmont",
      "name": "Fairmont · CBU",
      "operator": "NOAA",
      "location": "Fairmont, West Virginia",
      "sourceTitle": "NTIA Redbook, Fairmont Commerce earth stations",
      "sourceUrl": "https://redbook.ntia.gov/view/8-77",
      "role": "Consolidated backup operations",
      "members": [
        {
          "network": "noaa",
          "antennaId": "fairmont_164m_hr7"
        },
        {
          "network": "noaa",
          "antennaId": "fairmont_164m_hr8"
        },
        {
          "network": "noaa",
          "antennaId": "fairmont_164m_hr9"
        },
        {
          "network": "noaa",
          "antennaId": "fairmont_13m"
        }
      ],
      "lat": 39.433611111111105,
      "lon": -80.19333333333334,
      "extentM": 180,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/fairmont.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry. Location corrected to the shared Commerce Fairmont earth-station reference in NTIA Redbook chapter 8; not individual antenna pads."
    },
    {
      "id": "svalbard",
      "name": "Svalbard · SvalSat",
      "operator": "KSAT",
      "location": "Svalbard, Norway",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/technology/space-comms/near-space-network-complexes/",
      "role": "Partner ground station",
      "members": [
        {
          "network": "noaa",
          "antennaId": "svalbard_13m"
        },
        {
          "network": "noaa",
          "antennaId": "svalbard_4m"
        },
        {
          "network": "nasa",
          "antennaId": "svalbard_13m"
        }
      ],
      "lat": 78.2297,
      "lon": 15.398266666666666,
      "extentM": 303.2954585006373,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/svalbard.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "mcmurdo-noaa",
      "name": "McMurdo · NOAA terminals",
      "operator": "NOAA programme / partner site",
      "location": "McMurdo Station, Antarctica",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/technology/space-comms/near-space-network-complexes/",
      "role": "Polar data acquisition; planning inventory",
      "members": [
        {
          "network": "noaa",
          "antennaId": "mcmurdo_4m"
        },
        {
          "network": "noaa",
          "antennaId": "mcmurdo_4m_3"
        },
        {
          "network": "noaa",
          "antennaId": "mcmurdo_4m_2"
        }
      ],
      "lat": -77.8391,
      "lon": 166.6671,
      "extentM": 180,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/mcmurdo-noaa.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "goldstone",
      "name": "Goldstone Deep Space Communications Complex",
      "operator": "NASA DSN / partners",
      "location": "Barstow, California",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/directorates/somd/space-communications-navigation-program/what-is-the-deep-space-network/",
      "role": "Catalogue ground network facility",
      "members": [
        {
          "network": "nasa",
          "antennaId": "goldstone_70m"
        },
        {
          "network": "nasa",
          "antennaId": "goldstone_34m_1"
        },
        {
          "network": "nasa",
          "antennaId": "goldstone_34m_2"
        },
        {
          "network": "nasa",
          "antennaId": "goldstone_34m_3"
        }
      ],
      "lat": 35.360075,
      "lon": -116.878275,
      "extentM": 7572.691491691763,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/goldstone.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "canberra",
      "name": "Canberra Deep Space Communication Complex",
      "operator": "NASA DSN / partners",
      "location": "Tidbinbilla, ACT",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/directorates/somd/space-communications-navigation-program/what-is-the-deep-space-network/",
      "role": "Catalogue ground network facility",
      "members": [
        {
          "network": "nasa",
          "antennaId": "canberra_70m"
        },
        {
          "network": "nasa",
          "antennaId": "canberra_34m_1"
        },
        {
          "network": "nasa",
          "antennaId": "canberra_34m_2"
        },
        {
          "network": "nasa",
          "antennaId": "canberra_34m_3"
        }
      ],
      "lat": -35.39735,
      "lon": 148.9804,
      "extentM": 546.0236817316743,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/canberra.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "madrid",
      "name": "Madrid Deep Space Communications Complex",
      "operator": "NASA DSN / partners",
      "location": "Robledo de Chavela, Madrid",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/directorates/somd/space-communications-navigation-program/what-is-the-deep-space-network/",
      "role": "Catalogue ground network facility",
      "members": [
        {
          "network": "nasa",
          "antennaId": "madrid_70m"
        },
        {
          "network": "nasa",
          "antennaId": "madrid_34m_1"
        },
        {
          "network": "nasa",
          "antennaId": "madrid_34m_2"
        },
        {
          "network": "nasa",
          "antennaId": "madrid_34m_3"
        }
      ],
      "lat": 40.4285,
      "lon": -4.250249999999999,
      "extentM": 450.68900551501014,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/madrid.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "wallops-nasa",
      "name": "NASA Wallops ground station",
      "operator": "NASA network / partners",
      "location": "Wallops Island, Virginia",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/technology/space-comms/near-space-network-complexes/",
      "role": "Catalogue ground network facility",
      "members": [
        {
          "network": "nasa",
          "antennaId": "wallops_11m"
        },
        {
          "network": "nasa",
          "antennaId": "wallops_18m"
        }
      ],
      "lat": 37.93835,
      "lon": -75.46164999999999,
      "extentM": 347.80901109859354,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/wallops-nasa.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "fairbanks-asf",
      "name": "Fairbanks · NASA / ASF reference",
      "operator": "NASA network / partners",
      "location": "Fairbanks, Alaska",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/technology/space-comms/near-space-network-complexes/",
      "role": "Catalogue ground network facility",
      "members": [
        {
          "network": "nasa",
          "antennaId": "fairbanks_11m"
        }
      ],
      "lat": 64.8589,
      "lon": -147.851,
      "extentM": 180,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/fairbanks-asf.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "mcmurdo-nasa",
      "name": "McMurdo · NASA ground station",
      "operator": "NASA network / partners",
      "location": "McMurdo Station, Antarctica",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/technology/space-comms/near-space-network-complexes/",
      "role": "Catalogue ground network facility",
      "members": [
        {
          "network": "nasa",
          "antennaId": "mcmurdo_13m"
        }
      ],
      "lat": -77.85,
      "lon": 166.67,
      "extentM": 180,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/mcmurdo-nasa.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "nasa-santiago-chile",
      "name": "Santiago, Chile",
      "operator": "NASA network / partners",
      "location": "Santiago, Chile",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/technology/space-comms/near-space-network-complexes/",
      "role": "Catalogue ground network facility",
      "members": [
        {
          "network": "nasa",
          "antennaId": "santiago_9m"
        }
      ],
      "lat": -33.15,
      "lon": -70.67,
      "extentM": 180,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/nasa-santiago-chile.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "nasa-singapore",
      "name": "Singapore",
      "operator": "NASA network / partners",
      "location": "Singapore",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/technology/space-comms/near-space-network-complexes/",
      "role": "Catalogue ground network facility",
      "members": [
        {
          "network": "nasa",
          "antennaId": "singapore_13m"
        }
      ],
      "lat": 1.35,
      "lon": 103.82,
      "extentM": 180,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/nasa-singapore.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "nasa-hartebeesthoek-gauteng",
      "name": "Hartebeesthoek, Gauteng",
      "operator": "NASA network / partners",
      "location": "Hartebeesthoek, Gauteng",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/technology/space-comms/near-space-network-complexes/",
      "role": "Catalogue ground network facility",
      "members": [
        {
          "network": "nasa",
          "antennaId": "hartebeesthoek_10m"
        }
      ],
      "lat": -25.89,
      "lon": 27.69,
      "extentM": 180,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/nasa-hartebeesthoek-gauteng.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "nasa-troll-station-queen-maud-land",
      "name": "Troll Station, Queen Maud Land",
      "operator": "NASA network / partners",
      "location": "Troll Station, Queen Maud Land",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/technology/space-comms/near-space-network-complexes/",
      "role": "Catalogue ground network facility",
      "members": [
        {
          "network": "nasa",
          "antennaId": "troll_7m"
        }
      ],
      "lat": -72.01,
      "lon": 2.53,
      "extentM": 180,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/nasa-troll-station-queen-maud-land.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "nasa-north-pole-alaska",
      "name": "North Pole, Alaska",
      "operator": "NASA network / partners",
      "location": "North Pole, Alaska",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/technology/space-comms/near-space-network-complexes/",
      "role": "Catalogue ground network facility",
      "members": [
        {
          "network": "nasa",
          "antennaId": "north_pole_11m"
        }
      ],
      "lat": 64.8,
      "lon": -147.5,
      "extentM": 180,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/nasa-north-pole-alaska.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "nasa-poker-flat-alaska",
      "name": "Poker Flat, Alaska",
      "operator": "NASA network / partners",
      "location": "Poker Flat, Alaska",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/technology/space-comms/near-space-network-complexes/",
      "role": "Catalogue ground network facility",
      "members": [
        {
          "network": "nasa",
          "antennaId": "poker_flat_11m"
        }
      ],
      "lat": 65.12,
      "lon": -147.47,
      "extentM": 180,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/nasa-poker-flat-alaska.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "white-sands",
      "name": "White Sands complex",
      "operator": "NASA network / partners",
      "location": "White Sands, New Mexico",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/technology/space-comms/near-space-network-complexes/",
      "role": "Catalogue ground network facility",
      "members": [
        {
          "network": "nasa",
          "antennaId": "white_sands_18m"
        },
        {
          "network": "nasa",
          "antennaId": "wsgt_1"
        },
        {
          "network": "nasa",
          "antennaId": "wsgt_2"
        },
        {
          "network": "nasa",
          "antennaId": "bts"
        }
      ],
      "lat": 32.539175,
      "lon": -106.60932500000001,
      "extentM": 697.0433741141588,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/white-sands.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "nasa-merritt-island-florida",
      "name": "Merritt Island, Florida",
      "operator": "NASA network / partners",
      "location": "Merritt Island, Florida",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/technology/space-comms/near-space-network-complexes/",
      "role": "Catalogue ground network facility",
      "members": [
        {
          "network": "nasa",
          "antennaId": "merritt_island_9m"
        }
      ],
      "lat": 28.51,
      "lon": -80.65,
      "extentM": 180,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/nasa-merritt-island-florida.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "nasa-dongara-western-australia",
      "name": "Dongara, Western Australia",
      "operator": "NASA network / partners",
      "location": "Dongara, Western Australia",
      "sourceTitle": "NASA NEN Users Guide Rev. 4 (2019), section 6.7",
      "sourceUrl": "https://explorers.larc.nasa.gov/2019APSMEX/SMEX/pdf_files/453-UG-002905.pdf",
      "role": "Catalogue ground network facility",
      "members": [
        {
          "network": "nasa",
          "antennaId": "dongara_13m"
        }
      ],
      "lat": -29.045772222222222,
      "lon": 115.34867777777777,
      "extentM": 180,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/nasa-dongara-western-australia.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry. Location follows published AUWA01 coordinates; current configuration is unverified."
    },
    {
      "id": "nasa-gran-canaria-canary-islands",
      "name": "Gran Canaria, Canary Islands",
      "operator": "NASA network / partners",
      "location": "Gran Canaria, Canary Islands",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/technology/space-comms/near-space-network-complexes/",
      "role": "Catalogue ground network facility",
      "members": [
        {
          "network": "nasa",
          "antennaId": "maspalomas_15m"
        }
      ],
      "lat": 27.76,
      "lon": -15.63,
      "extentM": 180,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/nasa-gran-canaria-canary-islands.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "nasa-dededo-guam",
      "name": "Dededo, Guam",
      "operator": "NASA network / partners",
      "location": "Dededo, Guam",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/technology/space-comms/near-space-network-complexes/",
      "role": "Catalogue ground network facility",
      "members": [
        {
          "network": "nasa",
          "antennaId": "stgt"
        }
      ],
      "lat": 13.61,
      "lon": 144.86,
      "extentM": 180,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/nasa-dededo-guam.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "nasa-table-mountain-california",
      "name": "Table Mountain, California",
      "operator": "NASA network / partners",
      "location": "Table Mountain, California",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/technology/space-comms/near-space-network-complexes/",
      "role": "Catalogue ground network facility",
      "members": [
        {
          "network": "nasa",
          "antennaId": "octl"
        }
      ],
      "lat": 34.3819,
      "lon": -117.6818,
      "extentM": 180,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/nasa-table-mountain-california.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "nasa-haleakala-hawaii",
      "name": "Haleakala, Hawaii",
      "operator": "NASA network / partners",
      "location": "Haleakala, Hawaii",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/technology/space-comms/near-space-network-complexes/",
      "role": "Catalogue ground network facility",
      "members": [
        {
          "network": "nasa",
          "antennaId": "lcrd_hi"
        }
      ],
      "lat": 20.7084,
      "lon": -156.257,
      "extentM": 180,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/nasa-haleakala-hawaii.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "nasa-kitt-peak-arizona",
      "name": "Kitt Peak, Arizona",
      "operator": "NASA network / partners",
      "location": "Kitt Peak, Arizona",
      "sourceTitle": "NASA ground network reference",
      "sourceUrl": "https://www.nasa.gov/technology/space-comms/near-space-network-complexes/",
      "role": "Catalogue ground network facility",
      "members": [
        {
          "network": "nasa",
          "antennaId": "next_gen_ogt"
        }
      ],
      "lat": 31.96,
      "lon": -111.5983,
      "extentM": 180,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/nasa-kitt-peak-arizona.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry."
    },
    {
      "id": "white-sands-optical",
      "name": "White Sands optical reference",
      "operator": "NASA",
      "location": "White Sands, New Mexico",
      "sourceTitle": "NASA Orion optical communications",
      "sourceUrl": "https://www.nasa.gov/technology/space-comms/o2o/",
      "role": "Optical planning reference; current terminal location unverified",
      "members": [
        {
          "network": "nasa",
          "antennaId": "ogt_ws"
        }
      ],
      "lat": 32.5429,
      "lon": -106.6133,
      "extentM": 180,
      "checkedAt": "2026-10-15",
      "mapUrl": "/data/sites/facilities/white-sands-optical.json",
      "note": "Antenna positions and diameters follow the planning catalogue. Coincident coordinates may be shared site references; they do not establish separate installed locations. Mapped footprints are geographic context; building uses, heights and equipment shapes are not surveyed. No live facility telemetry. The anchor uses the historical LLCD station location published by NASA ILRS, not a surveyed current O2O pad. The previous LCRD designation and remote coordinate were incorrect."
    }
  ]
}
